export default __webpack_public_path__ + "static/media/envoi.dab1b148.svg";